/** True for any 2xx response (200, 201 Created, 204, …). */
export function isSuccessfulHttpStatus(status: number): boolean {
  return status >= 200 && status < 300;
}

/** Send httpOnly refresh cookies on login, refresh, and API calls (same-origin `/dev-api-proxy`). */
export function withIncludeCredentials(init: RequestInit = {}): RequestInit {
  if (init.credentials !== undefined) {
    return init;
  }
  return { ...init, credentials: 'include' };
}

/** Omit cookies — public register must not send a stale httpOnly refresh cookie after logout. */
export function withOmitCredentials(init: RequestInit = {}): RequestInit {
  return { ...init, credentials: 'omit' };
}
